import { call, put, takeLatest } from "redux-saga/effects";
import {
    CreateUserSupplyOrderInit,
    CreateUserSupplyOrderSuccess,
    CreateUserSupplyOrderFailure
} from "./CreateUserSupplyOrderSlice";

import { _CALLPUTAPI } from "../../../api/apiHandler";
import {
    _SUPPLY_ORDER_ENDPOINTS,
    LOCALSESSIONDATAKEYS,
    SUCCESS
} from "../../../constants/AppConstants";

import i18next from "i18next";
import { handleError } from "../../SagaError";
import { getLocalSessionData, getUserDataByKey } from "../../../utils/Authentication/handleUserSession";

function __CREATEUSERSUPPLYORDERSERVICE(consumables) {
    const endpoint = _SUPPLY_ORDER_ENDPOINTS.CREATE_USER_SUPPLY_ORDER;
    const UID = getLocalSessionData(LOCALSESSIONDATAKEYS.UID);
    const deviceId=getLocalSessionData(LOCALSESSIONDATAKEYS.DEVICE_ID)
    const serialNumber=getLocalSessionData(LOCALSESSIONDATAKEYS.SERIAL_NUMBER)
    const sapBpID = getUserDataByKey('sapBpId');

    const payload = {
        "userId": UID,
        "deviceId": deviceId,
        "serialNumber": serialNumber,
        "sapBpId": sapBpID,
        "orderType": "free",
        "consumables": consumables

    }
    return _CALLPUTAPI(endpoint, payload)
         .then(response => {
        return response;
    })
    .catch((error) => {
        throw error;
    });
}

function* handleCreateUserSupplyOrder(action) {
    try {
        const consumables = action.payload;
        

        const response = yield call(__CREATEUSERSUPPLYORDERSERVICE, consumables);

        (response.actionStatus?.toUpperCase() === SUCCESS)
            ? yield put(CreateUserSupplyOrderSuccess(response))
            : yield* handleError(
                CreateUserSupplyOrderFailure,
                i18next.t("ERROR_CONTENT.ERR_INFO.TECHNICAL_ERROR")
            );
    } catch (error) {
        yield* handleError(CreateUserSupplyOrderFailure, error.message);
    }
}

export default function* watchCreateUserSupplyOrderService() {
    yield takeLatest(CreateUserSupplyOrderInit.type, handleCreateUserSupplyOrder);
}
